import zhTw from './zh-tw';
import en from './en';

export default {
  'zh-tw': zhTw,
  en,
};
